(function () {
  const root = document.querySelector('[data-bc-cart-drawer]');
  if (!root) return;

  const overlay = root.querySelector('[data-cart-drawer="overlay"]');
  const panel   = root.querySelector('[data-cart-drawer="panel"]');
  if (!overlay || !panel) return;

  let lastFocus = null;
  let hideTimer = null;

  const isOpen = () => panel.classList.contains('is-open');
  const FOCUSABLE = 'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  const open = () => {
    if (isOpen()) return;
    if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
    lastFocus = document.activeElement;
    overlay.hidden = false;
    requestAnimationFrame(() => {
      overlay.classList.add('is-open');
      panel.classList.add('is-open');
    });
    panel.setAttribute('aria-hidden', 'false');
    document.documentElement.setAttribute('data-bc-cart-drawer-open', 'true');
    panel.focus();
    document.dispatchEvent(new CustomEvent('bc:cart:drawer', { detail: { open: true } }));
    // Initialise the dispatch countdown now the drawer is shown. The drawer body is
    // rendered after bcDispatch.boot() runs at load, so its [data-bc-dispatch] element
    // is otherwise never initialised (swapDrawerBody only re-boots on cart updates).
    if (globalThis.bcDispatch && typeof globalThis.bcDispatch.boot === 'function') {
      globalThis.bcDispatch.boot();
    }
  };

  const close = () => {
    if (!isOpen()) return;
    overlay.classList.remove('is-open');
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    document.documentElement.removeAttribute('data-bc-cart-drawer-open');
    if (hideTimer) clearTimeout(hideTimer);
    hideTimer = setTimeout(() => { overlay.hidden = true; hideTimer = null; }, 280);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    document.dispatchEvent(new CustomEvent('bc:cart:drawer', { detail: { open: false } }));
  };

  document.addEventListener('bc:cart:open', open);

  overlay.addEventListener('click', close);
  root.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-drawer="close"]'))    close();
    if (e.target.closest('[data-cart-drawer="continue"]')) { close(); if (window.history.length > 1) window.history.back(); }
  });
  document.addEventListener('keydown', (e) => {
    if (!isOpen()) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'Tab') {
      const focusables = Array.from(panel.querySelectorAll(FOCUSABLE));
      if (!focusables.length) return;
      const first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  root.bcCartDrawer = { open, close };

  const SECTION_ID = 'cart-drawer';

  const dispatchCartUpdated = (cart) => {
    document.dispatchEvent(new CustomEvent('bc:cart:updated', {
      detail: { count: cart.item_count || 0, total: cart.total_price || 0 }
    }));
  };

  const updateBadgeCount = (cart) => {
    document.querySelectorAll('[data-cart="count"]').forEach((el) => {
      el.textContent = String(cart.item_count || 0);
    });
    // [data-cart="total"] is intentionally NOT updated here; server-rendered to honor shop money_format
  };

  const setLoading = (loading) => panel.classList.toggle('is-loading', loading);

  const swapDrawerBody = (sectionsHtml) => {
    const html = sectionsHtml && sectionsHtml[SECTION_ID];
    if (!html) return;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const newBody = parsed.querySelector('[data-cart-drawer="body"]');
    const currentBody = panel.querySelector('[data-cart-drawer="body"]');
    if (newBody && currentBody) currentBody.replaceWith(newBody);
    hydrateRecommendations();
    if (globalThis.bcDispatch && typeof globalThis.bcDispatch.boot === 'function') {
      globalThis.bcDispatch.boot();
    }
  };

  const fetchCartJson = async () => {
    try {
      const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      return r.ok ? r.json() : null;
    } catch (_) { return null; }
  };

  // X-BC-Cart: 1 merker temaets egne kurvkall, slik at snippets/bc-cart-watch.liquid
  // ikke tolker dem som endringer fra en app og laster skuffen en gang til.
  const callChange = async (body) => {
    setLoading(true);
    try {
      const r = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-BC-Cart': '1' },
        body: JSON.stringify({ ...body, sections: SECTION_ID })
      });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        document.dispatchEvent(new CustomEvent('bc:cart:error', { detail: err }));
        return;
      }
      const data = await r.json();
      if (data.sections) swapDrawerBody(data.sections);
      const cart = await fetchCartJson();
      if (cart) { updateBadgeCount(cart); dispatchCartUpdated(cart); }
    } finally {
      setLoading(false);
    }
  };

  panel.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cart-change]');
    if (!btn) return;
    e.preventDefault();
    const action = btn.getAttribute('data-cart-change');
    const key = btn.getAttribute('data-line-key');
    if (!key) return;
    if (action === 'remove') {
      callChange({ id: key, quantity: 0 });
    } else {
      const li = panel.querySelector(`li[data-line-key="${CSS.escape(key)}"]`);
      const input = li && li.querySelector('[data-cart-quantity-input]');
      const current = Number((input && input.value) || 1);
      const next = action === 'increase' ? current + 1 : Math.max(0, current - 1);
      callChange({ id: key, quantity: next });
    }
  });

  const inputTimers = new Map();
  panel.addEventListener('input', (e) => {
    const input = e.target.closest('[data-cart-quantity-input]');
    if (!input) return;
    const key = input.getAttribute('data-line-key');
    if (!key) return;
    const next = Math.max(0, parseInt(input.value, 10) || 0);
    if (inputTimers.has(key)) clearTimeout(inputTimers.get(key));
    inputTimers.set(key, setTimeout(() => { callChange({ id: key, quantity: next }); }, 500));
  });

  let noteTimer = null;
  panel.addEventListener('input', (e) => {
    if (!e.target.matches('[data-cart-note]')) return;
    const note = e.target.value;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(async () => {
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-BC-Cart': '1' },
          body: JSON.stringify({ note })
        });
      } catch (err) {
        document.dispatchEvent(new CustomEvent('bc:cart:error', { detail: { message: String(err) } }));
      }
    }, 500);
  });

  function hydrateRecommendations () {
    const wrap = panel.querySelector('[data-cart-recommendations]');
    if (!wrap) return;
    if (root.dataset.showRecommendations !== 'true') return;
    let items = [];
    try { items = JSON.parse(localStorage.getItem('bc_last_seen') || '[]'); } catch (_) {}
    if (!Array.isArray(items) || items.length === 0) {
      wrap.hidden = true;
      return;
    }
    const pdpRoot = document.querySelector('[data-bc-product-id]');
    const currentId = pdpRoot ? pdpRoot.getAttribute('data-bc-product-id') : null;
    const visible = items
      .filter((it) => String(it.id) !== String(currentId))
      .slice(0, 4);
    if (!visible.length) { wrap.hidden = true; return; }
    const list = wrap.querySelector('[data-cart-recommendations-list]');
    list.innerHTML = visible.map((it) => `
      <li>
        <a href="${it.url || '#'}">
          ${it.image ? `<img src="${it.image}" alt="" loading="lazy">` : '<span class="bc-cart-drawer__recs-placeholder" aria-hidden="true"></span>'}
          <span>${(it.title || '').replace(/[<>&]/g, (c) => ({ '<': '&lt;', '>': '&gt;', '&': '&amp;' }[c]))}</span>
        </a>
      </li>
    `).join('');
    wrap.hidden = false;
  }

  document.addEventListener('bc:cart:drawer', (e) => {
    if (e.detail && e.detail.open) hydrateRecommendations();
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const action = form.getAttribute('action') || '';
    if (!action.includes('/cart/add')) return;
    event.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(form);
      formData.append('sections', SECTION_ID);
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-BC-Cart': '1' },
        body: formData
      });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        document.dispatchEvent(new CustomEvent('bc:cart:error', { detail: err }));
        return;
      }
      const result = await r.json();
      if (result.sections) swapDrawerBody(result.sections);
      const cart = await fetchCartJson();
      if (cart) { updateBadgeCount(cart); dispatchCartUpdated(cart); }
      open();
      const added = result.items || [result];
      added.forEach((item) => {
        document.dispatchEvent(new CustomEvent('bc:cart:item-added', {
          detail: {
            id: item.product_id,
            variant_id: item.variant_id,
            name: item.product_title,
            variant: item.variant_title,
            quantity: item.quantity,
            price: item.final_line_price || item.price
          }
        }));
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'add_to_cart', {
            currency: cart && cart.currency,
            value: ((item.final_line_price || item.price) || 0) / 100,
            items: [{ item_id: item.product_id, item_name: item.product_title, item_variant: item.variant_title, quantity: item.quantity }]
          });
        }
      });
    } finally {
      setLoading(false);
    }
  });

  // ── Bogos-bro (23.09.2026) ──────────────────────────────────────────────────────
  // Bogos (BOGOS.io Free Gift) legger varer i kurven og setter rabattkoder
  // med sin egen fetch-referanse, forbi temaets skjema-lytter over. Uten denne
  // blokken ble verken skuffen, antallet eller summen i headeren oppdatert før
  // neste sidelasting. Bogos sender derimot standard kurvhendelser på
  // document — de lytter vi på her. Verifisert i innlogget økt 23.09:
  // «Legg til i kurv (10% OFF)» sender apps:product-added-to-cart, cart:refresh,
  // cart:update, bogos:cart-updated, bogos:discount-added og fg-cart:end-process.
  // Hendelsene kommer i en klynge, så oppdateringen debounces (300 ms).
  //
  // 27.09.2026: pakke-widgeten til Bogos sendte ikke alltid disse hendelsene,
  // så skuffen ble stående gammel. snippets/bc-cart-watch.liquid lytter nå på
  // selve kurvkallene og sender bc:cart:external — se nederst.
  const refresh = async () => {
    try {
      const [cart, sectionsRes] = await Promise.all([
        fetchCartJson(),
        // NB: ingen Accept-header her — med «Accept: application/json» leverer
        // Shopify ikke section-HTML-en, og skuffen ble stående tom (testet 23.09).
        fetch(window.location.pathname + '?sections=' + SECTION_ID)
          .then((r) => (r.ok ? r.json() : null))
          .catch(() => null)
      ]);
      if (sectionsRes) swapDrawerBody(sectionsRes);
      if (cart) { updateBadgeCount(cart); dispatchCartUpdated(cart); }
    } catch (_) {}
  };
  root.bcCartDrawer.refresh = refresh;

  let externalTimer = null;
  let externalOpen = false;
  const scheduleExternal = (openAfter) => {
    if (openAfter) externalOpen = true;
    if (externalTimer) clearTimeout(externalTimer);
    externalTimer = setTimeout(async () => {
      externalTimer = null;
      const shouldOpen = externalOpen;
      externalOpen = false;
      await refresh();
      if (shouldOpen) open();
    }, 300);
  };
  ['cart:refresh', 'cart:update', 'bogos:cart-updated', 'bogos:discount-added', 'fg-cart:end-process']
    .forEach((name) => document.addEventListener(name, () => scheduleExternal(false)));
  document.addEventListener('apps:product-added-to-cart', () => scheduleExternal(true));

  // Kurvkall fra apper, fanget av snippets/bc-cart-watch.liquid (27.09.2026).
  // detail.added er true bare for /cart/add som kom rett etter et klikk — da
  // åpnes skuffen. Automatiske gaver fra Bogos oppdaterer den uten å åpne.
  document.addEventListener('bc:cart:external', (e) => {
    scheduleExternal(!!(e.detail && e.detail.added));
  });
})();
